import { Suspense } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Routes } from '../../../../app/routes';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import LoginForm from '../../components/login-form/login-form';
import { selectIsAuthenticated, setDomain, setIsDomainPrefilled } from '../../store/auth-slice';

const Login = (): JSX.Element => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  if (isAuthenticated) {
    const domain = searchParams.get('domain');
    if (searchParams.has('domain') && domain) {
      dispatch(setIsDomainPrefilled(true));
      dispatch(setDomain(domain));
    }

    return <Navigate replace to={Routes.Main} />;
  }

  return (
    <Suspense>
      <LoginForm />
    </Suspense>
  );
};

export default Login;
